module.exports = __webpack_public_path__ + "static/media/navTemplateActive.5d4edb3e.svg";